import { createFileRoute, notFound, redirect } from '@tanstack/react-router'
import * as React from 'react'
import { resolveSession } from '../features/auth/session'
import { canSeeProjects, projectLaneFromSlug } from '../features/projects/api'
import { PortfolioScreen, type PortfolioSearch, parsePortfolioSearch } from '../features/projects/portfolio'

export const Route = createFileRoute('/projects/$lane')({
  validateSearch: (raw: Record<string, unknown>): PortfolioSearch => parsePortfolioSearch(raw),
  beforeLoad: async ({ context, params }) => {
    if (!projectLaneFromSlug(params.lane)) throw notFound()
    const session = await resolveSession(context.queryClient)
    if (session.kind !== 'signed_in') return
    if (session.me.ui_mode === 'simple') throw redirect({ to: '/my-day' })
    if (!canSeeProjects(session.me.role)) throw redirect({ to: '/' })
  },
  component: function ProjectLaneRoute() {
    const search = Route.useSearch()
    const { lane: slug } = Route.useParams()
    const navigate = Route.useNavigate()
    const lane = projectLaneFromSlug(slug)
    const onSearch = React.useCallback(
      (patch: Partial<PortfolioSearch>) =>
        void navigate({ search: (previous: PortfolioSearch) => parsePortfolioSearch({ ...previous, ...patch }), replace: true }),
      [navigate],
    )
    if (!lane) return null
    return <PortfolioScreen lane={lane} search={search} onSearch={onSearch} />
  },
})
